import DIApi from './_diApi';
// / Api cho loại tài khoản tiền gửi kho bạc
class BankInfoCategoryAPI extends DIApi {
  controllerName = 'BankInfoCategorys';
}

export default new BankInfoCategoryAPI();
